// extracted by mini-css-extract-plugin
export default {"wrapper":"PositionModuleWrapper_wrapper__b6jJb"};